// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DaMY","colBig":"styles_colBig__1nKZF","colSmall":"styles_colSmall__22SPK"};